var map = {
	"./chain-archway-1.svg": 5688,
	"./chain-cataclysm-1.svg": 69354,
	"./chain-constantine-3.svg": 9788,
	"./chain-neutron-1.svg": 85999,
	"./chain-nibiru-testnet-1.svg": 78495,
	"./chain-pion-1.svg": 60209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8317;